import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchProfileObjects } from '../actions/profileObjectActions';

export default function useProfileObjects(profileId) {
    const dispatch = useDispatch();
    const { profileObjects } = useSelector(
        ({ profileObjects }) => profileObjects
    );
    const [loading, setLoading] = useState(false);
    const [fetchedId, setFetchedId] = useState('');
    const [errors, setErrors] = useState([]);

    // Fetch the profile objects if needed
    useEffect(() => {
        if (!profileId) {
            return;
        }
        if (loading || fetchedId === profileId) {
            return;
        }
        const runFetchProfileObjects = async () => {
            setFetchedId(profileId);
            setLoading(true);
            setErrors([]);
            try {
                await dispatch(fetchProfileObjects(profileId));
                setLoading(false);
            } catch (error) {
                setFetchedId('');
                setLoading(false);
                setErrors([error]);
            }
        };
        runFetchProfileObjects();
    }, [fetchedId, loading, profileId]);

    return { errors, loading, profileId, profileObjects };
}
